import { render, staticRenderFns } from "./appPackageList.vue?vue&type=template&id=ccc2e456&scoped=true"
import script from "./appPackageList.vue?vue&type=script&lang=js"
export * from "./appPackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc2e456",
  null
  
)

export default component.exports